import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

// Manual language persistence without auto-detection
const getSavedLang = (): string => {
  try {
    const saved = localStorage.getItem('neurobaby_lang');
    if (saved === 'es' || saved === 'en') return saved;
  } catch {
    // localStorage not available, use default
  }
  return 'es';
};

i18n
  .use(initReactI18next)
  .init({
    lng: getSavedLang(),
    fallbackLng: 'es',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

// Persist language choice whenever it changes
i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem('neurobaby_lang', lng);
  } catch {
    // localStorage not available, silently ignore
  }
});

export default i18n;